import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { event } from '@uhg-abyss/web/tools/event';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';
import { Link } from '@uhg-abyss/web/ui/Link';
import { IntroSection } from './IntroSection';
import { LagoonContext } from '@src/AppContext';
import { Testimonials } from '@src/common/Testimonials/Testimonials';
import { testimonialMock } from '@src/content_data/testimonialMock';

const StyledLink = styled(Link, {});
const LinkText = styled('span', { fontSize: '15px' });

const Wrapper = styled('div', {
  '@screen >= $xs': {
    padding: '16px',
  },
  '@screen >= $xl': {
    padding: 0,
  },
});

const TitleStyle = styled('h1', {
  color: 'rgb(0, 38, 119)',
  fontSize: '32px ! important',
  fontWeight: '600',
  marginTop: '50px',
  lineHeight: '40px',
});

const ContainerListItems = styled('li', {
  listStyle: 'disc',
  color: '#196ECF',
  whiteSpace: 'nowrap',
});

const Container = styled('div', {
  display: 'grid',
  marginLeft: '25px',
  marginTop: '28px',
  marginBottom: '-40px',
  '@screen >= $xs': {
    gridTemplateRows: 'repeat(7, 1fr)',
    gridAutoFlow: 'column',
  },
  '@screen >= $xl': {
    gridTemplateRows: 'repeat(4, 1fr)',
    gridAutoFlow: 'column',
  },
});

const TestimonialsWrapper = styled('div', {
  marginTop: '70px',
  marginBottom: '7px',
});

const baseItems = [
  {
    title: 'Claim appeals (with attachments)',
    url: '/knowledge-base/claims-overview',
  },
  {
    title: 'Claim reconsiderations (with attachments)',
    url: '/knowledge-base/claims-overview',
  },
  {
    title: 'Claim status and payments',
    url: '/knowledge-base/claims-overview',
  },
  {
    title: 'Dental',
    url: '/knowledge-base/dental-overview',
  },
  {
    title: 'Documents',
    url: '/knowledge-base/claims-overview',
  },
  {
    title: 'Eligibility and benefits',
    url: '/knowledge-base/eligibility-benefits-overview',
  },
  {
    title: 'Prior authorizations',
    url: '/knowledge-base/priorauth-overview',
  },
  {
    title: 'Provider Access',
    url: '/knowledge-base/provideraccess-overview',
  },
  {
    title: 'Provider demographic update API',
    url: '/knowledge-base/provider-demographic-overview',
  },
  {
    title: 'Referrals',
    url: '/knowledge-base/referrals-overview',
  },
  {
    title: 'Super Connector',
    url: '/all-apis/super-connector-api',
  },
  {
    title: 'TrackIt',
    url: '/knowledge-base/trackit-overview',
  },
];

export const NewGettingStarted = () => {
  const [itemsState, setItemsState] = useState(baseItems);
  const dsUserInfo = useSelector((state) => {
    return state.GET_DS_USER_INFO.data;
  });
  const userInfo = useSelector((state) => {
    return state.GET_USER_INFO.data;
  });
  const { navigate } = useRouter();
  const lagoonContext = React.useContext(LagoonContext);
  const featureToggles = lagoonContext?.getTable('feature-toggles');
  const providerAccessToggle = featureToggles?.getRow(
    'PROVIDER_ACCESS_TOGGLE'
  )?.enabled;

  const filtered = useMemo(() => {
    let list = baseItems;
    if (providerAccessToggle === false) {
      list = list.filter((i) => {
        return i.title !== 'Provider Access';
      });
    }
    return list;
  }, [providerAccessToggle]);

  useEffect(() => {
    setItemsState(filtered);
  }, [filtered]);

  useEffect(() => {
    event('GETTING_STARTED_PAGE_LOAD', { dsUserInfo, userInfo });
  }, []);

  return (
    <React.Fragment>
      <Wrapper>
        <IntroSection />
        <TitleStyle>APIs we offer</TitleStyle>
        <Container>
          {itemsState.map((el) => {
            return (
              <div>
                <ul>
                  <ContainerListItems>
                    <StyledLink
                      onClick={() => {
                        return navigate(el.url);
                      }}
                    >
                      <LinkText>{el.title}</LinkText>
                    </StyledLink>
                  </ContainerListItems>
                </ul>
              </div>
            );
          })}
        </Container>
        <TestimonialsWrapper>
          <Testimonials initialData={testimonialMock} />
        </TestimonialsWrapper>
      </Wrapper>
    </React.Fragment>
  );
};
